// Logo Malzeme sayfasi. Grid + detay (ResourceListPage generic) + birim alt-grid'i.
import DataGrid, { Column, Editing, Scrolling } from 'devextreme-react/data-grid';
import { ResourceListPage, ResourceConfig, FieldSpec } from '../components/ResourceListPage';
import { Material, emptyMaterial } from '../types';
import { getMaterials, saveMaterial } from '../api/materials';

const CARD_TYPE = [
  { id: 1, name: 'Ticari Mal (1)' },
  { id: 2, name: 'Karma Koli (2)' },
  { id: 3, name: 'Depozitolu (3)' },
  { id: 4, name: 'Sabit Kiymet (4)' },
  { id: 10, name: 'Hammadde (10)' },
  { id: 11, name: 'Yari Mamul (11)' },
  { id: 12, name: 'Mamul (12)' },
];

const columns = [
  { dataField: 'code', caption: 'Kod', width: 130 },
  { dataField: 'name', caption: 'Malzeme Adi', width: 'auto' },
  { dataField: 'unitSetCode', caption: 'Birim Seti', width: 110 },
  { dataField: 'groupCode', caption: 'Grup Kodu', width: 120 },
  { dataField: 'producerCode', caption: 'Uretici Kodu', width: 130 },
  { dataField: 'vat', caption: 'KDV %', width: 80, alignment: 'right' as const },
  {
    dataField: 'isActive', caption: 'Durum', width: 90, alignment: 'center' as const,
    cellRender: (d: any) => (d.data.isActive ? 'Aktif' : 'Pasif'),
  },
];

const fields: FieldSpec[] = [
  // Genel
  { field: 'code', label: 'Kod', required: true, tab: 'Genel' },
  { field: 'name', label: 'Malzeme Adi', required: true, tab: 'Genel' },
  { field: 'name2', label: 'Ad 2', tab: 'Genel' },
  { field: 'name3', label: 'Ad 3', tab: 'Genel' },
  { field: 'name4', label: 'Ad 4', tab: 'Genel' },
  { field: 'cardType', label: 'Kart Tipi', editor: 'select', items: CARD_TYPE, tab: 'Genel' },
  { field: 'unitSetCode', label: 'Birim Seti', tab: 'Genel' },
  { field: 'groupCode', label: 'Grup Kodu', tab: 'Genel' },
  { field: 'producerCode', label: 'Uretici Kodu', tab: 'Genel' },
  { field: 'isActive', label: 'Aktif', editor: 'check', tab: 'Genel' },

  // Ozel kodlar
  { field: 'auxilCode', label: 'Ozel Kod 1', tab: 'Ozel Kodlar' },
  { field: 'auxilCode2', label: 'Ozel Kod 2', tab: 'Ozel Kodlar' },
  { field: 'auxilCode3', label: 'Ozel Kod 3', tab: 'Ozel Kodlar' },
  { field: 'auxilCode4', label: 'Ozel Kod 4', tab: 'Ozel Kodlar' },
  { field: 'auxilCode5', label: 'Ozel Kod 5', tab: 'Ozel Kodlar' },
  { field: 'markCode', label: 'Marka', tab: 'Ozel Kodlar' },

  // Kullanim bayraklari + KDV detayi
  { field: 'usefPurchasing', label: 'Satinalmada Kullan', editor: 'check', tab: 'Kullanim / KDV' },
  { field: 'usefSales', label: 'Satista Kullan', editor: 'check', tab: 'Kullanim / KDV' },
  { field: 'usefMm', label: 'MM', editor: 'check', tab: 'Kullanim / KDV' },
  { field: 'vat', label: 'KDV %', editor: 'number', tab: 'Kullanim / KDV' },
  { field: 'selVat', label: 'Satis KDV', editor: 'number', tab: 'Kullanim / KDV' },
  { field: 'returnVat', label: 'Iade KDV', editor: 'number', tab: 'Kullanim / KDV' },
  { field: 'selPrVat', label: 'Satis Peragende KDV', editor: 'number', tab: 'Kullanim / KDV' },
  { field: 'returnPrVat', label: 'Iade Peragende KDV', editor: 'number', tab: 'Kullanim / KDV' },

  // Override bayraklari (null=default)
  { field: 'tool', label: 'Tool', editor: 'number', tab: 'Override' },
  { field: 'autoIncSl', label: 'AutoIncSl', editor: 'number', tab: 'Override' },
  { field: 'lotsDivisible', label: 'Lot Bolunebilir', editor: 'number', tab: 'Override' },
  { field: 'imageInc', label: 'Resim 1', editor: 'number', tab: 'Override' },
  { field: 'img2Inc', label: 'Resim 2', editor: 'number', tab: 'Override' },
  { field: 'updateChilds', label: 'Alt Guncelle', editor: 'number', tab: 'Override' },
  { field: 'extAccFlags', label: 'ExtAccFlags', editor: 'number', tab: 'Override' },
  { field: 'extCrdFlags', label: 'ExtCrdFlags', editor: 'number', tab: 'Override' },
  { field: 'multiAddTax', label: 'Coklu Ek Vergi', editor: 'number', tab: 'Override' },
  { field: 'packet', label: 'Paket Malzemesi', editor: 'number', tab: 'Override' },
  { field: 'addTaxPurchBrws', label: 'Ek Vergi Satinalma', editor: 'number', tab: 'Override' },
  { field: 'addTaxSalesBrws', label: 'Ek Vergi Satis', editor: 'number', tab: 'Override' },
  { field: 'distLotUnits', label: 'Lot Dagit', editor: 'number', tab: 'Override' },
  { field: 'combLotUnits', label: 'Lot Birlestir', editor: 'number', tab: 'Override' },

  // Tevkifat
  { field: 'saleDeductionPart1', label: 'Satis Tevkifat 1', editor: 'number', tab: 'Tevkifat' },
  { field: 'saleDeductionPart2', label: 'Satis Tevkifat 2', editor: 'number', tab: 'Tevkifat' },
  { field: 'purchDeductionPart1', label: 'Alis Tevkifat 1', editor: 'number', tab: 'Tevkifat' },
  { field: 'purchDeductionPart2', label: 'Alis Tevkifat 2', editor: 'number', tab: 'Tevkifat' },
  { field: 'deductCode', label: 'Tevkifat Kodu', tab: 'Tevkifat' },
  { field: 'deductDef', label: 'Tevkifat Aciklama', tab: 'Tevkifat' },
  { field: 'purchDeductCode', label: 'Alis Tevkifat Kodu', tab: 'Tevkifat' },
  { field: 'canDeduct', label: 'Tevkifat Uygulanir', editor: 'number', tab: 'Tevkifat' },
  { field: 'appSpeVatMatrah', label: 'Ozel Matrah', editor: 'number', tab: 'Tevkifat' },

  // Lojistik / is kurallari
  { field: 'paymentCode', label: 'Odeme Plani', tab: 'Lojistik' },
  { field: 'shelfLife', label: 'Raf Omru (gun)', editor: 'number', tab: 'Lojistik' },
  { field: 'distPoint', label: 'Dagitim Puani', editor: 'number', tab: 'Lojistik' },
  { field: 'avrWhDuration', label: 'Ort. Ambar Suresi', editor: 'number', tab: 'Lojistik' },
  { field: 'pordAmountTolerance', label: 'Satinalma Sip. Tol.', editor: 'number', tab: 'Lojistik' },
  { field: 'sordAmountTolerance', label: 'Satis Sip. Tol.', editor: 'number', tab: 'Lojistik' },
  { field: 'noDiscount', label: 'Iskonto Yok', editor: 'number', tab: 'Lojistik' },
  { field: 'profitMarginRate', label: 'Kar Marji %', editor: 'number', tab: 'Lojistik' },
  { field: 'draftOfferBrws', label: 'Taslak Teklif', editor: 'number', tab: 'Lojistik' },
  { field: 'tibbiCihaz', label: 'Tibbi Cihaz', editor: 'number', tab: 'Lojistik' },
];

const config: ResourceConfig<Material> = {
  keyExpr: 'code',
  columns,
  fields,
  load: (onlyActive) => getMaterials({ onlyActive }),
  save: (m) => saveMaterial(m),
  newItem: emptyMaterial,
  headerLabel: (m) => (m.code ? `${m.code} — ${m.name}` : 'Yeni Malzeme'),
  hasActiveFilter: true,
  extraDetail: (m) => {
    if (!m.units) m.units = [];
    return (
      <div style={{ marginTop: 12 }}>
        <div style={{ fontSize: 13, fontWeight: 600, margin: '4px 0 6px' }}>Birimler / Barkodlar</div>
        <DataGrid dataSource={m.units} keyExpr="unitCode" showBorders columnAutoWidth height={220}>
          <Scrolling mode="virtual" />
          <Editing mode="cell" allowAdding allowUpdating allowDeleting useIcons />
          <Column dataField="unitCode" caption="Birim" width={100} />
          <Column dataField="convFact1" caption="Cevrim 1" dataType="number" width={90} />
          <Column dataField="convFact2" caption="Cevrim 2" dataType="number" width={90} />
          <Column dataField="width" caption="En" dataType="number" width={80} />
          <Column dataField="length" caption="Boy" dataType="number" width={80} />
          <Column dataField="height" caption="Yuk." dataType="number" width={80} />
          <Column dataField="weight" caption="Agirlik" dataType="number" width={90} />
          <Column dataField="grossWeight" caption="Brut Agirlik" dataType="number" width={110} />
          <Column dataField="volume" caption="Hacim" dataType="number" width={90} />
        </DataGrid>
      </div>
    );
  },
};

export default function LogoMaterialsPage() {
  return <ResourceListPage config={config} />;
}
